import i18n from "i18next";
import type { FC } from "react";

import { PrimaryButton } from "../Buttons/components/ActionButton";

export type GenerateButtonProps = {
    onClick: () => void;
};

export const GenerateButton: FC<GenerateButtonProps> = ({ onClick }) => {
    return (
        <PrimaryButton name="generate_button" onClick={onClick}>
            {i18n.t("button.generate")}
        </PrimaryButton>
    );
};
